module.exports = __webpack_public_path__ + "static/UnclickOutPatientMedicalYellow-feec48a0063d93ac57ddecd4f72d9d66.png";